import * as yup from 'yup';

export default yup.object().shape({
  title: yup.string().max(255),
  content: yup.object().shape({
    _id: yup.string().required(),
  }),
  sendAt: yup.date(),
});
